import { TriangleAlert } from "lucide-react";
import { isRouteErrorResponse, Link, useRouteError } from "react-router";

import NotFoundPage from "@/app/routes/NotFoundPage";
import { useT } from "@/shared/i18n/useT";
import { Button } from "@/shared/ui/Button";
import { EmptyState } from "@/shared/ui/EmptyState";
import { buttonVariants } from "@/shared/ui/styles";

const HTTP_NOT_FOUND = 404;

/** Shown when a route throws while rendering or loading; offers a reload, never a blank page. */
export function RouteError() {
  const t = useT();
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === HTTP_NOT_FOUND) return <NotFoundPage />;

  return (
    <div className="mx-auto flex w-full max-w-2xl flex-1 flex-col justify-center px-4 py-16">
      <EmptyState
        icon={TriangleAlert}
        tone="danger"
        title={t("errors.unexpected.title")}
        body={t("errors.unexpected.body")}
        action={
          <div className="flex flex-wrap justify-center gap-2">
            <Button
              onClick={() => {
                window.location.reload();
              }}
            >
              {t("common.retry")}
            </Button>
            <Link to="/" className={buttonVariants({ variant: "secondary" })}>
              {t("errors.unexpected.home")}
            </Link>
          </div>
        }
      />
    </div>
  );
}
